export const STATUSES = {
    'booked': "fa fa-thumbs-up booked",
    'no_show': "fas fa-eye-slash no_show",
    'late': "fa fa-clock late",
    'arrived_late': "fa fa-thumbs-up arrived_late",
    'arrived': "fa fa-thumbs-up arrived",
    'in_progress': "fa fa-hand-holding-heart in_progress",
    'is_done': "fa fa-check is_done",
    'neutral': "far fa-circle neutral"
};